import { render, staticRenderFns } from "./ShopModal.vue?vue&type=template&id=34750629&scoped=true&"
import script from "./ShopModal.vue?vue&type=script&lang=js&"
export * from "./ShopModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34750629",
  null
  
)

export default component.exports